import * as actionsRequest from './request/actions';
import * as actionsOngoing from './ongoing/actions';
import * as constants from './constants';
import reducer from './reducer';

export default {
    actions: { ...actionsRequest, ...actionsOngoing },
    constants,
    reducer
};



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/index.js